export default __webpack_public_path__ + "static/media/RajaRajeshwari.503facfc.png";